import React, { useRef } from "react"
import { Button, Dropdown, Typography } from "@mimber/ui-web"
import { MoreOutlined, EditOutlined, StopOutlined } from "@mimber/ui-web"
import { usePermissionedMenuItems } from "@/core/hooks/usePermissionedMenuItems"
import { useDeactivateEventTicketTierModal } from "@/components/modals/DeactivateEventTicketTierModal"
import { EditEventTicketTierModal } from "@/components/modals/EditEventTicketTierModal"
import { Resource, Action } from "@mimber/schema"
import type { PermissionedMenuItem } from "@/core/hooks/usePermissionedMenuItems"
import type { EventTicketTierActionsDropdownProps } from "./EventTicketTierActionsDropdown.types"

const { Text } = Typography

export const EventTicketTierActionsDropdown: React.FunctionComponent<
  EventTicketTierActionsDropdownProps
> = ({
  eventUuid,
  tier,
  onActionComplete,
  size = "small",
  type = "text",
  iconOnly = true,
}) => {
  const openEditRef = useRef<(() => void) | null>(null)

  const { contextHolder, showDeactivateEventTicketTierModal } =
    useDeactivateEventTicketTierModal(eventUuid, onActionComplete)

  const menuItems: PermissionedMenuItem[] = [
    {
      key: "edit",
      label: "Edit",
      icon: <EditOutlined />,
      resource: Resource.EVENT,
      action: Action.UPDATE,
      onClick: () => openEditRef.current?.(),
    },
    ...(tier.isActive
      ? ([
          {
            key: "deactivate",
            label: "Deactivate",
            icon: <StopOutlined />,
            danger: true,
            resource: Resource.EVENT,
            action: Action.UPDATE,
            onClick: () => showDeactivateEventTicketTierModal(tier),
          },
        ] as PermissionedMenuItem[])
      : []),
  ]

  const { items } = usePermissionedMenuItems({ items: menuItems })

  if (items.length === 0) {
    return <Text type="secondary">&mdash;</Text>
  }

  return (
    <>
      {contextHolder}
      <EditEventTicketTierModal
        eventUuid={eventUuid}
        tier={tier}
        onSuccess={onActionComplete}
        renderButton={(open) => {
          openEditRef.current = open
          return <></>
        }}
      />
      <Dropdown menu={{ items }} trigger={["click"]}>
        <Button
          type={type}
          icon={iconOnly ? <MoreOutlined /> : undefined}
          size={size}
        >
          {!iconOnly && "Actions"}
        </Button>
      </Dropdown>
    </>
  )
}
